export default () => {
  return ['#FFBBA6', // kasumi
          '#7FBBEE', // otae
          '#FFAADD', // rimi
          '#FFE588', // saya
          '#D4B2EE', // chomama
          '#F67F90', // red_mesh
          '#7FE5D4', // bread_jankie
          '#FFCCCC', // himari
          '#DD7F99', // soiya
          '#FFF6C3', // tsugu
          '#FFC3DD', // maruyama
          '#AAEEF6', // runnnn!!
          '#FFF6D4', // chisato
          '#CCEEC3', // huhehe...
          '#EEDDFF', // bushidoooooo!!!
          '#C388C3', // nyaaan_chan
          '#7FD4DD', // potato
          '#EE907F', // risa
          '#EE7FC3', // ako
          '#DDDDDD', // rinko
          '#FFF690', // kokoro
          '#D499E5', // hakanai
          '#FFCC90', // hagu
          '#A1EEFF', // hueee...
          '#84B1CD'] // girl_in_the_michelle
}
